<style lang="scss">
.package-title{
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #ff9900;
    color: #fff;
}
</style>

<template>
    <div>
        <div class="bg-fff margin-top-20 padding-bottom-20" >
            <header class="package-title font-bold">包裹信息</header>
            <Table
            class="margin-10"
            :columns="columns" 
            :data="formList"
            size="small" 
            ref="table"  
            border 
            stripe></Table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props: ['comPackages', 'type', 'status', 'parentId'],
    data() {
        return {
            
        }
    },
    created() {

    },
    computed:{
        formList(){
            return this.comPackages || []
        },
        columns() {
            return [{
                title: 'Tracking NO',
                key: 'trackingNo',
                render(h, { row }) {
                    return <div>
                    {row.trackingNo}
                    </div>
                }
            }, {
                title: 'Carrier',
                key: 'carrier',
                render(h, { row }) {
                    return <div>
                    {row.carrier}
                    </div>
                }
            }, {
                title: 'ERP SKU',
                key: 'erpSku',
                render(h, { row }) {
                    return <div>{row.erpSku}</div>
                }
            }, {
                title: '发货数量',
                key: 'shipedQuantity',
                render(h, { row }) {
                    return <div>{row.shipedQuantity}</div>
                }
            },{
                title: '发货时间',
                key: 'shipmentDate',
                render(h, { row }) {
                    return <div>{row.shipmentDate}</div>
                }
            },]
        },
    },
    methods: {

    },

}
</script>

